<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['templates.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">
        {{ 'TEMPLATES.TEMPLATES_LIST.TITLE' | translate }}
      </h5>
    </div>
    <div class="col-auto ms-auto button-container">
      <button type="button" class="btn btn-link buttonst" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <p-fileUpload
        *ngIf="accessService.hasAccess([], ['templates.import'])"
        [styleClass]="'btn btn-upload buttonst'"
        [chooseLabel]="'TEMPLATES.TEMPLATES_LIST.IMPORT' | translate"
        #fileUploader
        name="file"
        [multiple]="false"
        [auto]="true"
        [showUploadButton]="false"
        [showCancelButton]="false"
        customUpload="true"
        (uploadHandler)="import($event, fileUploader)"
        mode="basic"
      ></p-fileUpload>

      <button *ngIf="accessService.hasAccess([], [])" type="button" class="btn btn-secondary buttonst" (click)="export()">
        {{ 'TEMPLATES.TEMPLATES_LIST.EXPORT' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([], ['templates.store'])"
        type="button"
        class="btn btn-secondary buttonst"
        (click)="add()"
      >
        {{ 'TEMPLATES.TEMPLATES_LIST.ADD_TEMPLATE' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="templatesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Templates', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'CURRENCIES.CURRENCIES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'TEMPLATES.TEMPLATES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'TEMPLATES.TEMPLATES_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="subject"
      title="{{ 'TEMPLATES.TEMPLATES_LIST.SUBJECT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('subject')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="company.abbreviation"
      title="{{ 'TEMPLATES.TEMPLATES_LIST.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.abbreviation')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/settings/companies/view']" [queryParams]="{ id: dataItem?.company_id }" target="_blank">
          {{ dataItem?.company?.shortName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="locale.name"
      title="{{ 'TEMPLATES.TEMPLATES_LIST.LOCALE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('locale.name')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="type.value"
      title="{{ 'TEMPLATES.TEMPLATES_LIST.TYPE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('type.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'template'" [filter]="filter"></app-kendo-type-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'TEMPLATES.TEMPLATES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button *ngIf="accessService.hasAccess([], ['templates.show'])" (click)="edit(dataItem)">
        </app-edit-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([], ['templates.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
